export const strategies = [
  {
    id: 'patrimonial', icon: '🏛️',
    title: 'Patrimonial Premium', subtitle: 'Tel Aviv – Valeur refuge',
    cityId: 'tel-aviv', profile: 'Investisseur patrimonial long terme',
    description: 'Tel Aviv est l\'équivalent d\'un bien haussmannien parisien : cher, mais structurellement demandé. On n\'achète pas ici pour le rendement immédiat, mais pour la protection du capital et la valorisation sur 10–20 ans.',
    typicalAsset: '2–3 pièces dans Florentin, Neve Tzedek, Rothschild, Old North',
    priceRange: { min: 3500000, max: 6000000 },
    grossYieldRange: { min: 2.0, max: 3.0 },
    riskLevel: 'faible', horizon: '10–20 ans',
    pros: ['Marché le plus liquide d\'Israël', 'Demande internationale soutenue', 'Protection du capital en ILS et en €', 'Forte communauté francophone'],
    cons: ['Ticket d\'entrée élevé (> 1 M€)', 'Rendement locatif brut faible (2–3 %)', 'Cash-flow souvent négatif en financement partiel'],
    tip: 'Privilégiez les biens avec terrasse ou toit-terrasse : ils se valorisent davantage et sont très demandés sur Airbnb.',
  },
  {
    id: 'equilibre', icon: '⚖️',
    title: 'Équilibre Prix / Rendement', subtitle: 'Haïfa – Le choix rationnel',
    cityId: 'haifa', profile: 'Investisseur rendement / primo-accédant',
    description: 'Haïfa offre ce que Tel Aviv ne peut plus donner : prix raisonnable (–55 % vs Tel Aviv) avec rendement correct (4–4,5 %). Ville universitaire et technologique, demande locative stable.',
    typicalAsset: '2–3 pièces sur le Carmel ou dans Hadar HaCarmel',
    priceRange: { min: 1200000, max: 2200000 },
    grossYieldRange: { min: 3.9, max: 4.5 },
    riskLevel: 'faible', horizon: '7–15 ans',
    pros: ['Prix accessibles (300 000–600 000 €)', 'Rendement brut de 4–4,5 %', 'Demande étudiante et tech stable', 'Bonne qualité de vie'],
    cons: ['Moins de glamour que Tel Aviv', 'Marché essentiellement local', 'Perception de proximité du nord pour certains'],
    tip: 'Carmel Center et Ahuza combinent qualité de vie et demande locative. Évitez les Wadi (stationnement difficile).',
  },
  {
    id: 'airbnb', icon: '🌴',
    title: 'Potentiel Airbnb', subtitle: 'Tel Aviv / Eilat – Cash-flow maximal',
    cityId: 'eilat', profile: 'Investisseur actif, orienté cash-flow',
    description: 'Une stratégie Airbnb bien exécutée peut générer 8–12 % de rendement brut. Tel Aviv (centre-ville) et Eilat (mer Rouge, zone franche) sont les marchés les plus porteurs.',
    typicalAsset: 'Studio ou 2 pièces bien situé, meublé et équipé',
    priceRange: { min: 900000, max: 2500000 },
    grossYieldRange: { min: 6.0, max: 12.0 },
    riskLevel: 'élevé', horizon: '3–10 ans',
    pros: ['Revenus 2–3× la location classique', 'Flexibilité d\'usage personnel', 'Marchés touristiques profonds', 'Revenus peu corrélés aux marchés financiers'],
    cons: ['Gestion intensive (conciergerie, ménage)', 'Réglementation en évolution', 'Saisonnalité forte à Eilat', 'Risque de vacance lors de tensions'],
    tip: 'Budgétez 20–25 % du CA Airbnb pour la conciergerie. Le net sera 5–8 %, mais sans contrainte de gestion.',
  },
];
